import React from 'react';
import styles from "./CustomInputDateField.module.css";
import {RootState} from "../../../app/store";
import {useAppSelector} from "../../../app/hooks";

interface Props {
    title: string
    valueSelector: (state: RootState) => string | undefined
    updateValue: (update: string) => void;
}

export const CustomInputDateField = ({
                                         title,
                                         valueSelector,
                                         updateValue
                                     }: Props) => {

    const value = useAppSelector(valueSelector)

    return <div className={styles.wrapper}>
        <span className={styles.title}>{title}</span>
        <input
            type="date"
            value={value}
            onChange={(e) => {
                if (e.target.value) {
                    updateValue(e.target.value)
                }
            }
            }
        />
    </div>
}
